import { useTranslation } from "next-i18next";
import React from "react";

import { Icon } from "@/components/elements/Icon";
import { Text } from "@/components/elements/Text";

import LinkExternal from "../elements/LinkExternal";
import styles from "./styles.module.css";

const Contact = ({ title, description, email, name, address }) => (
  <div className={styles.contact} key={title}>
    <Text as="h3" size="m">
      {title}
    </Text>
    <Text>{description}</Text>
    {name ? <Text className={styles.contactName}>{name}</Text> : null}
    {address ? <Text>{address}</Text> : null}
    <Text className={styles.contactInfo}>
      <span className={styles.iconBg}>
        <Icon type="email" />
      </span>

      <LinkExternal href={`mailto:${email}`}>{email}</LinkExternal>
    </Text>
  </div>
);

export default function ContactInfo() {
  const { t } = useTranslation("contact");

  const CONTACTS = [
    {
      title: t("marketing_title"),
      description: t("marketing_description"),
      email: "hello@pafyll.com",
    },
    {
      title: t("pr_and_comms_title"),
      description: t("pr_and_comms_description"),
      email: "hello@pafyll.com",
    },
    {
      title: t("business_enquiries_title"),
      description: t("business_enquiries_description"),
      email: "said.molavi@orkla.no",
      name: "Said Molavi, Customer Director Value Trade",
      address: "Drammensveien 149 - 0277 Oslo",
    },
  ];

  return <div>{CONTACTS.map(Contact)}</div>;
}
